import React from 'react';
import { Flex, Box } from 'rebass';
import { navigate } from '@reach/router';

export default (props) => {
  return (
    <Flex
      width="84%"
      height="5%"
      color="#CBCFD4"
      fontSize='14px'
      alignItems='center'
      justifyContent='center'
      id={`nav_${props.nav}`}
      style={{ cursor: 'pointer'}}
      onClick = {() => navigate(`#${props.nav}`)}
    >
      <Box>{props.text}</Box>
    </Flex>
  )
}
